import { Box, Button, Grid, TextField } from "@mui/material";
import { publicClient } from "@toorak/tc-common-fe-sdk";
import React, { useEffect, useState } from "react";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  addProvision,
  deleteProvision,
  getProvisionHistory,
  updateProvision
} from "../../../stores/drawRequest/drawRequest.action";
import { useDrawsStyles } from "../Draws.styles";
import { Header } from "../../../create-loan/home/Header";
import { setTabView } from "../../../stores/SettlementAndPurchase/SettlementAndPurchase.reducer";
import { ProvisionHistory } from "./ProvisionHistory";
import { getCookie } from "../../../utils/cookies";
import { apiUrlHost } from "../../../stores/servicerOnboarding/servicerOnboarding.action";

const AddProvisionView = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const classes = useDrawsStyles();
  const dispatch = useDispatch();
  const redirectToProvisionView = () => {
    navigate("/drawDetails/provisions");
  };

  const [provisionHistory, setProvisionHistory] = useState<any>([]);

  const [provisionVal, setProvisionVal] = useState<any>("");
  const { toorakLoanId } = useParams<any>() as any;
  const routeState = (location as any)?.state ?? {};

  const [loanDetails, setLoanDetails] = useState<any>({
    originatorLoanId: "",
    toorakLoanId: toorakLoanId ?? "NA",
    originatorName: ""
  });

  // const [isMinimizedProvision, setIsMinimizedProvision] = useState<boolean>(
  //   false
  // );

  const handleChange = (val: any) => {
    setProvisionVal(val);
  };

  const provisionHistorycallBack = (data: any, toorakLoanIdFromApi: string) => {
    setProvisionHistory(data);
    const derivedPrimaryLoanId = data?.[0]?.primaryLoanId || "";
    if (derivedPrimaryLoanId) {
      setLoanDetails((prev: any) => ({
        ...prev,
        originatorLoanId: prev?.originatorLoanId || derivedPrimaryLoanId
      }));
    }
    let value = "No";
    if (data.length !== 0) {
      value = "Yes";
    }
    const toorakLoanIdForUpdate =
      toorakLoanIdFromApi || loanDetails?.toorakLoanId || "";
    if (toorakLoanIdForUpdate) {
      dispatch(updateProvision(toorakLoanIdForUpdate, value));
    }
  };

  const hydrateLoanDetailsFromLoansList = async (targetToorakLoanId: string) => {
    try {
      const owner = getCookie("org_id");
      const isTestParty = getCookie("isTestParty") === "true";
      const url = `${apiUrlHost}/drawservice/assetmanagement/v2/draws/loans?owner=${owner}&isOriginator=false&isTestParty=${isTestParty}`;
      const response = (await publicClient.get(url)).data;
      const allLoans = Array.isArray(response) ? response : [];
      const selectedLoan =
        allLoans.find(
          (loan: any) => String(loan?.toorakLoanId) === String(targetToorakLoanId)
        ) || {};
      const fetchedName = selectedLoan?.originatorName ?? "";
      const fetchedPrimaryLoanId =
        selectedLoan?.primaryLoanId ?? selectedLoan?.originatorLoanId ?? "";
      setLoanDetails((prev: any) => ({
        ...prev,
        toorakLoanId: prev?.toorakLoanId || targetToorakLoanId,
        originatorLoanId: prev?.originatorLoanId || fetchedPrimaryLoanId,
        originatorName: fetchedName
      }));
    } catch (err) {
      console.error("Error hydrating provision loan details from loans API", err);
    }
  };

  useEffect(() => {
    if (routeState?.toorakLoanId) {
      const details = {
        originatorLoanId: routeState?.primaryLoanId ?? "",
        toorakLoanId: routeState.toorakLoanId,
        originatorName: routeState?.originatorName ?? ""
      };
      setLoanDetails(details);
      dispatch(getProvisionHistory(details.toorakLoanId, provisionHistorycallBack));
      if (!details.originatorLoanId || !details.originatorName) {
        hydrateLoanDetailsFromLoansList(details.toorakLoanId);
      }
      return;
    }
    if (toorakLoanId) {
      dispatch(getProvisionHistory(toorakLoanId, provisionHistorycallBack));
      hydrateLoanDetailsFromLoansList(toorakLoanId);
    }
    // eslint-disable-next-line
  }, [toorakLoanId]);

  const editCallback = () => {
    dispatch(
      getProvisionHistory(
        loanDetails.toorakLoanId,
        provisionHistorycallBack
      )
    );
  };

  const editProvision = (
    originatorLoanId: any,
    toorakLoanId: any,
    provisionVal: any,
    provisionId: any
  ) => {
    dispatch(
      addProvision(
        originatorLoanId,
        toorakLoanId,
        provisionVal,
        provisionId,
        editCallback
      )
    );
  };

  const deleteCallback = () => {
    dispatch(
      getProvisionHistory(
        loanDetails.toorakLoanId,
        provisionHistorycallBack
      )
    );
  };
  const delProvision = (provisionId: any) => {
    dispatch(deleteProvision(provisionId, deleteCallback));
  };
  return (
    <>
      <Header
        value={3}
        setTabValue={setTabView}
        showTab
        showNotificationIcon={false}
      />
      <Grid item container xs={12} className={classes.provisionHeader}>
        <Grid
          item
          container
          xs={6}
          sm={6}
          md={8}
          xl={8}
          style={{ marginTop: "10px" }}
        >
          <Box
            className="button-typography-wrapper-left"
            style={{ padding: "4px 0px", marginLeft: "20px" }}
          >
            <Button
              variant="contained"
              data-testid="back-button"
              color="primary"
              startIcon={<KeyboardArrowLeftIcon />}
              onClick={redirectToProvisionView}
            >
              Back
            </Button>
          </Box>
          <span
            className={classes.drawHeaderDetails}
            style={{ marginTop: "10px" }}
          >
            <span className={classes.itemHeaderText}>
              Primary Loan Id: {loanDetails?.originatorLoanId || "__ __"}
            </span>
          </span>
        </Grid>
      </Grid>
      <Grid
        item
        container
        xs={12}
        data-testid="draw-view-itemContainer"
        className={classes.itemContainer}
      >
        <Grid item container xs={10} className={classes.itemHeaderText}>
          <h5 className={classes.itemHeaderText}>Existing Provisions</h5>
        </Grid>
        {/* <Grid
          item
          container
          xs={2}
          sm={2}
          md={2}
          xl={2}
          className={classes.expandCollapse}
        >
          <ExpandCollapse
            isMinimize={isMinimizedProvision}
            clicked={() => {
              setIsMinimizedProvision(!isMinimizedProvision);
            }}
            keyDown={() => {
              setIsMinimizedProvision(!isMinimizedProvision);
            }}
          />
        </Grid> */}
        <Grid
          item
          container
          xs={12}
          sm={12}
          md={12}
          xl={12}
          data-testid="draw-view-fieldContainer"
          className={classes.fieldContainer}
        >
          <Grid
            item
            container
            xs={12}
            sm={12}
            md={12}
            xl={12}
            data-testid="draw-view-primary-loan"
            className={classes.fieldRow}
          >
            {provisionHistory && (
              <ProvisionHistory
                historyData={provisionHistory}
                actionReq
                editProvision={editProvision}
                delProvision={delProvision}
              />
            )}
          </Grid>
        </Grid>
        <Grid
          item
          container
          xs={12}
          className={classes.itemHeaderText}
          data-testid="draw-view-itemHeaderText"
        >
          <TextField
            variant="outlined"
            value={provisionVal}
            placeholder="Enter Provision"
            onChange={(e) => handleChange(e.target.value)}
            sx={{
              "& .MuiOutlinedInput-root": {
                backgroundColor: "#ffffff",
                "& fieldset": {
                  borderColor: "#98a2b3",
                  borderWidth: "1px"
                },
                "&:hover fieldset": {
                  borderColor: "#667085"
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#172b4d",
                  borderWidth: "2px"
                },
                "& input": {
                  color: "#172b4d"
                },
                "& input::placeholder": {
                  color: "#667085",
                  opacity: 1
                }
              }
            }}
            InputProps={{
              style: {
                backgroundColor: "#ffffff"
              }
            }}
            style={{
              width: "100%",
              marginTop: "40px"
            }}
          />
        </Grid>
        <Grid item container xs={12} data-testid="draw-view-itemHeaderText">
          <Button
            variant="contained"
            color="primary"
            disabled={provisionVal === "" || loanDetails?.toorakLoanId === "NA"}
            classes={{ root: classes.provisionButton }}
            onClick={() => {
              if (
                loanDetails?.toorakLoanId &&
                loanDetails?.originatorLoanId &&
                provisionVal !== ""
              ) {
                dispatch(
                  addProvision(
                    loanDetails.originatorLoanId,
                    loanDetails.toorakLoanId,
                    provisionVal,
                    false,
                    () => {
                      dispatch(
                        getProvisionHistory(
                          loanDetails.toorakLoanId,
                          provisionHistorycallBack
                        )
                      );
                    }
                  )
                );
                setProvisionVal("");
              }
            }}
          >
            Add
          </Button>
        </Grid>
        <Grid
          item
          container
          xs={12}
          className={classes.itemHeaderText}
          style={{ marginTop: "40px" }}
          data-testid="draw-view-itemHeaderText"
        >
          Loan Details
        </Grid>
        <Grid
          item
          container
          xs={12}
          data-testid="draw-view-fieldContainer"
          className={classes.fieldContainer}
        >
          <Grid item container xs={12}>
            <Grid
              item
              container
              xs={5}
              data-testid="draw-view-primary-loan"
              className={classes.fieldRow}
            >
              <div className={classes.itemBox}>
                <p
                  className={classes.itemSubHeaderText}
                  data-testid="draw-primary-loan-id"
                >
                  Toorak Loan Id
                </p>
                {loanDetails?.toorakLoanId ? (
                  <p
                    className={classes.itemValueText}
                    data-testid="originator-loanId-value"
                  >
                    {loanDetails.toorakLoanId}
                  </p>
                ) : (
                  <p
                    className={classes.itemValueText}
                    data-testid="originator-loanId-blank"
                  >
                    __ __
                  </p>
                )}
              </div>
            </Grid>
            <Grid
              item
              container
              xs={5}
              data-testid="draw-view-primary-loan"
              className={classes.fieldRow}
            >
              <div className={classes.itemBox}>
                <p
                  className={classes.itemSubHeaderText}
                  data-testid="draw-primary-loan-id"
                >
                  Primary Loan Id
                </p>
                {loanDetails?.originatorLoanId ? (
                  <p
                    className={classes.itemValueText}
                    data-testid="originator-loanId-value"
                  >
                    {loanDetails.originatorLoanId}
                  </p>
                ) : (
                  <p
                    className={classes.itemValueText}
                    data-testid="originator-loanId-blank"
                  >
                    __ __
                  </p>
                )}
              </div>
            </Grid>
            <Grid
              item
              container
              xs={2}
              data-testid="draw-view-primary-loan"
              className={classes.fieldRow}
            >
              <div className={classes.itemBox}>
                <p
                  className={classes.itemSubHeaderText}
                  data-testid="draw-primary-loan-id"
                >
                  Originator Name
                </p>
                {loanDetails?.originatorName ? (
                  <p
                    className={classes.itemValueText}
                    data-testid="originator-loanId-value"
                  >
                    {loanDetails.originatorName}
                  </p>
                ) : (
                  <p
                    className={classes.itemValueText}
                    data-testid="originator-loanId-blank"
                  >
                    __ __
                  </p>
                )}
              </div>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default AddProvisionView;